export default "__VITE_ASSET__Dyludn21__"